import { Bandeira } from "./bandeira";
import { DatePipe } from '@angular/common';

export class Uteis {

    public isValidUrl(value: string) {
        try {
            new URL(value);
            return true;
        } catch (err) {
            return false;
        }
    }

    public getFlagUrl(sigla: string) {
        if (!sigla) {
            return null;
        }

        const code = sigla.trim().toLowerCase();

        // exceções
        if (code === 'ac') {
            // Ascensão não costuma existir como flag separada no FlagCDN;
            // usamos SH como fallback do território Saint Helena, Ascension and Tristan da Cunha
            return 'https://flagcdn.com/w20/sh.png';
        }

        return `https://flagcdn.com/w20/${code}.png`;
    }

    public getBandeiraImg(sigla: string): { img: string; pais: string } | null {

        if (!sigla) {
            return null;
        }

        const bandeiras = Bandeira;
        const siglaNormalizada = sigla.trim().toUpperCase();
        const bandeira = bandeiras.find(x => x.sigla === siglaNormalizada);

        const img = this.getFlagUrl(siglaNormalizada) ?? `https://flagcdn.com/w20/${siglaNormalizada.toLowerCase()}.png`;
        const pais = bandeira?.pais ?? siglaNormalizada;

        return { img: img, pais: pais };
    }

    public getDiferencaEntreDatas(dataInicio: string, dataFim: string, unidadeMedida = 'd') {
        const data_inicio = new Date(dataInicio);
        const data_fim = new Date(dataFim);

        // Calcular a diferença em milissegundos
        const diferencaMs = data_fim.getTime() - data_inicio.getTime();

        let retorno = 0;
        // Converter a diferença de milissegundos para dias
        switch (unidadeMedida) {
            case 'd': {
                retorno = diferencaMs / (1000 * 60 * 60 * 24);
                break;
            }
        }

        return Math.round(retorno);

    }


    public exibirPrimeiroNome(nomeCompleto: string) {
        const nomes = nomeCompleto.trim().split(' ');
        return nomes[0];
    }

    public getDataFormatada(data: string, formato: string = 'dd/MM/yyyy HH:mm'): any {
        const datePipe = new DatePipe('pt-BR'); // Define o locale
        return datePipe.transform(data, formato);
    }

    public getOrCreateDeviceId() {
        let deviceId = localStorage.getItem('device_id');

        if (!deviceId) {
            deviceId = crypto.randomUUID().replace('-', '').replace('_', ''); // Gera um UUID único
            localStorage.setItem('device_id', deviceId);
        }

        return deviceId;
    }

    public maskEmail(email: string): string {
        if (!email) {
            return '';
        }
        const [user, domain] = email.split('@');
        if (!user || !domain) return email;

        const visible = user.slice(0, 3); // mantém os 2 primeiros caracteres
        return `${visible}***@${domain}`;
    }

}
